import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, MapPin, Star, CheckCircle2, ArrowRight } from 'lucide-react';
const CALENDLY_URL = 'https://calendly.com/vantixcredit/diagnostico-de-credito';
const contactInfo = [{
  icon: Phone,
  label: 'Llamanos',
  value: '+1 (407) 367-8672'
}, {
  icon: Mail,
  label: 'Escribenos',
  value: 'eduardo@vantixcreditsolutions.com'
}, {
  icon: MapPin,
  label: 'Servicio',
  value: '100% Done For You'
}];
const consultaItems = ['Revisamos tu situacion actual y metas', 'Identificamos oportunidades rapidas', 'Te damos un plan claro sin compromiso', 'Sin presion, sin venta agresiva'];
const sessionStats = [{
  value: '30 min',
  label: 'Duracion'
}, {
  value: 'Gratis',
  label: 'Sin costo'
}, {
  value: '100%',
  label: 'Confidencial'
}];
export function Booking() {
  return <section id="agendar" className="bg-black py-32 px-4 sm:px-6 lg:px-8 border-t border-white/5 relative overflow-hidden" data-id="element-14">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(245,158,11,0.05),transparent_50%)] pointer-events-none" data-id="element-15" />

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-16">
        {/* Heading */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-center mb-20" data-id="element-17">
          <span className="inline-block text-xs font-semibold tracking-[0.3em] uppercase bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent mb-6" data-id="element-18">
            Comienza Ahora
          </span>
          <h2 className="text-4xl md:text-6xl font-bold text-white tracking-tight mb-6 leading-[1.1]" data-id="element-19">
            Has Llegado Hasta Aqui.
            <br data-id="element-20" />
            <span className="italic font-black bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-21">
              Ahora Toma Accion.
            </span>
          </h2>
          <p className="text-lg md:text-xl text-white/50 font-light max-w-2xl mx-auto" data-id="element-22">
            Agenda tu consulta gratuita y recibe un plan de accion personalizado
            para tu credito.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start" data-id="element-23">
          {/* Left: contact info + checklist */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }} className="space-y-8 order-2 lg:order-1" data-id="element-24">
            {/* Contact rows */}
            <div className="space-y-5" data-id="element-25">
              {contactInfo.map((item, i) => <div key={i} className="flex items-center gap-4" data-id="element-26">
                  <div className="h-12 w-12 rounded-2xl bg-gradient-to-b from-amber-300/20 to-amber-600/10 border border-amber-500/20 flex items-center justify-center shrink-0" data-id="element-27">
                    <item.icon className="h-5 w-5 text-amber-400" strokeWidth={2} data-id="element-28" />
                  </div>
                  <div data-id="element-29">
                    <div className="text-xs font-semibold tracking-[0.2em] uppercase text-white/40 mb-1" data-id="element-30">
                      {item.label}
                    </div>
                    <div className="text-white font-semibold text-lg" data-id="element-31">
                      {item.value}
                    </div>
                  </div>
                </div>)}
            </div>

            {/* En tu consulta box */}
            <div className="rounded-3xl border border-white/[0.08] bg-gradient-to-b from-white/[0.04] to-white/[0.01] p-8" data-id="element-32">
              <div className="text-xs font-semibold tracking-[0.2em] uppercase text-white/40 mb-6" data-id="element-33">
                En tu consulta:
              </div>
              <ul className="space-y-4" data-id="element-34">
                {consultaItems.map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-35">
                    <CheckCircle2 className="h-5 w-5 text-amber-400 shrink-0" strokeWidth={2} data-id="element-36" />
                    <span className="text-white/70 font-light" data-id="element-37">{item}</span>
                  </li>)}
              </ul>
            </div>
          </motion.div>

          {/* Right: booking card */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.8,
          delay: 0.15,
          ease: [0.16, 1, 0.3, 1]
        }} className="rounded-3xl border border-amber-500/30 bg-gradient-to-b from-amber-500/[0.06] to-transparent shadow-2xl shadow-amber-500/5 p-8 md:p-12 text-center order-1 lg:order-2" data-id="element-38">
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-5" data-id="element-39">
              Agenda Tu Sesion{' '}
              <span className="italic bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-40">
                Gratis
              </span>
            </h3>
            <p className="text-white/50 font-light leading-relaxed mb-10 max-w-md mx-auto" data-id="element-41">
              Selecciona el dia y hora que mejor te convenga. En 30 minutos
              tendras claridad total sobre tu camino a un mejor credito y
              financiamiento.
            </p>

            <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 bg-gradient-to-b from-amber-300 via-amber-400 to-amber-600 hover:brightness-110 text-black font-semibold px-8 py-4 rounded-full transition-all text-lg shadow-2xl shadow-amber-500/30 w-full" data-id="element-42">
              Reservar Mi Consulta Gratis
              <ArrowRight className="h-5 w-5" data-id="element-43" />
            </a>
            <p className="mt-5 text-sm text-white/40 font-light" data-id="element-44">
              Sin spam. Tu informacion es 100% confidencial.
            </p>

            {/* Divider */}
            <div className="h-px w-full bg-white/[0.08] my-10" data-id="element-45" />

            {/* Session stats */}
            <div className="grid grid-cols-3 gap-4" data-id="element-46">
              {sessionStats.map((stat, i) => <div key={i} data-id="element-47">
                  <div className="text-xl md:text-2xl font-bold bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent mb-1" data-id="element-48">
                    {stat.value}
                  </div>
                  <div className="text-sm text-white/40 font-light" data-id="element-49">
                    {stat.label}
                  </div>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}